module.exports = __webpack_public_path__ + "public/img/qdgq.a846fee6.png";